import React from 'react';
import { IconType } from 'react-icons';
import './ActionButton.css';

interface ActionButtonProps {
  icon: IconType;
  text: string;
  onClick: () => void;
  variant: 'detail' | 'metrics' | 'edit' | 'delete' | 'primary';
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  icon: Icon,
  text,
  onClick,
  variant,
  disabled = false,
}) => {
  return (
    <button
      className={`action-btn action-btn-${variant}`}
      onClick={onClick}
      disabled={disabled}
      title={text}
      aria-label={text}
    >
      <span className="btn-icon">{React.createElement(Icon as React.ComponentType)}</span>
      <span className="btn-text">{text}</span>
    </button>
  );
};

export default ActionButton;
